var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden
    ? _c(
        "section",
        { staticClass: "insta text-center", style: _vm.paddingStyles },
        [
          _c(
            "header",
            { staticClass: "insta__header" },
            [
              _c(
                "h3",
                {
                  staticClass: "insta__title",
                  class: [_vm.schema.settings.sectionHeaderColor]
                },
                [_vm._v(_vm._s(_vm.schema.settings.sectionHeader))]
              ),
              _c(
                "v-link",
                {
                  attrs: {
                    target: "_blank",
                    href: _vm.schema.settings.linkUrl,
                    primary: ""
                  }
                },
                [_vm._v(_vm._s(_vm.schema.settings.linkText))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "insta__slider" },
            [
              _vm.images.length
                ? _c(
                    "swiper",
                    {
                      ref: "swiper",
                      attrs: { id: "insta-swiper", options: _vm.swiperOptions }
                    },
                    _vm._l(_vm.images, function(image) {
                      return _c("swiper-slide", { key: image.thumbnail.url }, [
                        _c("div", {
                          staticClass: "insta__img",
                          style:
                            "background-image: url(" +
                            image.standard_resolution.url +
                            ")",
                          attrs: { alt: "" }
                        })
                      ])
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "button",
                {
                  staticClass: "insta__prev",
                  attrs: {
                    "aria-label": "Go to previous slide",
                    "aria-controls": "insta-swiper"
                  },
                  on: {
                    click: function() {
                      _vm.$refs.swiper.swiper.slidePrev()
                    }
                  }
                },
                [_c("icon", { attrs: { name: "arrow_left", size: "32px" } })],
                1
              ),
              _c(
                "button",
                {
                  staticClass: "insta__next",
                  attrs: {
                    "aria-label": "Go to next slide",
                    "aria-controls": "insta-swiper"
                  },
                  on: {
                    click: function() {
                      _vm.$refs.swiper.swiper.slideNext()
                    }
                  }
                },
                [_c("icon", { attrs: { name: "arrow_right", size: "32px" } })],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }